import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Sidebar from "./Sidebar";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const columns = [
  { id: "email_address", label: "Email", minWidth: 170, maxWidth: 170 },
  { id: "positive_thumbs", label: "+ve Count", minWidth: 100, maxWidth: 100 },
  { id: "negative_thumbs", label: "-ve Count", minWidth: 100, maxWidth: 100 },
  { id: "quiz_title", label: "Quiz Title", minWidth: 100, maxWidth: 100 },
  { id: "student_name", label: "Student Name", minWidth: 100, maxWidth: 100 },
  {
    id: "teacher_feedback_submission_timestamp",
    label: "Feedback submission Time",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
];

export default function StickyHeadTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const [rows, setRows] = useState([]);

  useEffect(() => {
    getWebUsersFeedbackAgainstTeepeeFeedback();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const getWebUsersFeedbackAgainstTeepeeFeedback = () => {
    var token = "Bearer " + localStorage.getItem("access_token");
    axios
      .request({
        method: "GET",
        url:
          process.env.REACT_APP_REST_API_BASE_URL +
          "/get_web_users_feedback_against_teepee_feedback",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          authorization: token,
        },
      })
      .then((res) => {
        var web_user_feedback_against_teepee_feedback =
          res.data.web_user_feedback_against_teepee_feedback;
        console.log(web_user_feedback_against_teepee_feedback);
        setRows(web_user_feedback_against_teepee_feedback);
      });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const navigate = useNavigate();
  const userType = localStorage.getItem("user_type");
  useEffect(() => {
    if (userType === "1") {
      navigate("/");
      return;
    }
  }, [navigate, userType]);

  const handleSeeMoreClick = (event, quizRow) => {
    event.preventDefault();
    navigate("/quiz-detail-review", {
      state: {
        student_name: quizRow["student_name"],
        quiz_response_id: quizRow["quiz_response_id"],
        title: quizRow["quiz_title"],
        quiz_performace: quizRow["performance"],
        quiz_secret_key: quizRow["secret_key"],
        show_teacher_feedback: true,
        rubric:false
      },
    });
  };

  return (
    <>
      <Sidebar item_id="evaluation_feedback" />
      <div className="sm:ml-[5px] sm:mr-[5px] md:ml-[316px] ">
        <div className="home sm:ml[25px] md:ml-[60px]">
          <div>
            <label className="dashboard-label">
              Teepee's evaluation feedback
            </label>
            <div className="teepee-divider"></div>
          </div>
        </div>
        <div className="flex flex-row justify-left items-center sm:ml-[10px] md:ml-[60px] mt-[20px] sm:mr-[10px] md:mr-[60px]">
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 840 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{
                          minWidth: column.minWidth,
                          backgroundColor: "#f7f2f9",
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                    <TableCell
                      key={"action"}
                      align={"right"}
                      style={{ minWidth: "50px", backgroundColor: "#f7f2f9" }}
                    >
                      View Details
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.code}
                        >
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                style={{
                                  minWidth: column.minWidth,
                                  maxWidth: column.maxWidth,
                                  overflowWrap: "break-word",
                                }}
                                key={column.id}
                                align={column.align}
                              >
                                {column.id === "positive_thumbs" ? (
                                  <div className="flex center">
                                    <span
                                      className={`material-symbols-rounded like-active  material-icons`}
                                    >
                                      thumb_up
                                    </span>
                                    <div className="ml-[5px]">{value}</div>
                                  </div>
                                ) : column.id === "negative_thumbs" ? (
                                  <div className="flex center">
                                    <div className="mr-[5px]">{value}</div>
                                    <span
                                      className={`material-symbols-rounded dislike-active  material-icons`}
                                    >
                                      thumb_down
                                    </span>
                                  </div>
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                          <TableCell
                            key={"action"}
                            align={"right"}
                            style={{ minWidth: "50px" }}
                          >
                            <a
                              href="/"
                              onClick={(event) => {
                                handleSeeMoreClick(event, row);
                              }}
                              className="active"
                            >
                              See more{" "}
                            </a>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              style={{ backgroundColor: "#f7f2f9" }}
              rowsPerPageOptions={[100, 150, 200]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </div>
    </>
  );
}
